import React from 'react'

import { Flex, StatusMessage } from '@driftt/dds'

import PasswordInput from 'components/PasswordInput'
import { meetsAllRequirements } from 'utils/password'

const showWarning = (password, config, passwordUpdateStatus) => {
  return (
    passwordUpdateStatus === 'failed' && !meetsAllRequirements(password, config)
  )
}

export const PasswordSection = ({
  password,
  passwordConfig,
  passwordConfigFetched,
  passwordUpdateStatus,
  onPasswordChange,
  missingPasswordConfig,
}) => (
  <Flex direction="column" alignItems="center" fullWidth>
    <PasswordInput
      label="Create password"
      value={password}
      passwordConfig={passwordConfig}
      passwordConfigFetched={passwordConfigFetched}
      passwordUpdateStatus={passwordUpdateStatus}
      onChange={onPasswordChange}
    />
    {missingPasswordConfig ? (
      <StatusMessage variant="error">
        We couldn't find your organization's password requirements. Please try
        again!
      </StatusMessage>
    ) : (
      showWarning(password, passwordConfig, passwordUpdateStatus) && (
        <StatusMessage variant="error">
          Your password is almost secure! Make sure that you meet all
          requirements.
        </StatusMessage>
      )
    )}
  </Flex>
)
